/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationUserModel } from '../../models/organization-user-model';

export interface OrganizationFhirIdUsersGet$Params {
  fhirId: string;
}

export function organizationFhirIdUsersGet(http: HttpClient, rootUrl: string, params: OrganizationFhirIdUsersGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<Array<OrganizationUserModel>>> {
  const rb = new RequestBuilder(rootUrl, organizationFhirIdUsersGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<Array<OrganizationUserModel>>;
    })
  );
}

organizationFhirIdUsersGet.PATH = '/Organization/{fhirId}/Users';
